// Question definitions for the SCS "Safety in Special Groups & Situations"
// wizard.
//
// Mirrors scsAnalysisOfAdverseEventsQuestions / scsClinicalLaboratoryEvaluations
// Questions — the three pages ask the same shaped questions (what to report on,
// which table, then one or more comparison groupings), so they share attribute
// names wherever the answer is the same answer: `number` is the stable badge
// shown in the CSR-style index badge (page order, hardcoded — it does not
// renumber as conditional sections toggle), `text` is the fallback wording and
// `tooltip` holds the ticket INFORMATION/helper text (the endpoint returns
// wording only, no tooltip map).
//
// At runtime the wording is overridden by
// GET /clinical_summaries/safety_summary/questions, keyed by the same attribute
// the answer is stored under. `textKey` names the attribute to read that
// wording from when it differs from the local key — the comparison questions
// (Q5–Q7) are the Description of Studies questions repeated per grouping, so
// they reuse that page's wording and only their badge number changes.

export const SCS_SISG_QUESTIONS = {
  qSpecialSubgroups: {
    number: 1,
    text: "Which Safety subgroups, additional to gender, age and race, do you want to report on?",
    tooltip:
      "Gender, Age and Race are always reported and cannot be removed. Add any further subgroup by typing it in or picking it from the suggestions (e.g. alcohol use, smoking, liver disease, renal disease, drug interactions).",
  },
  qSpecialSubgroupTable: {
    number: 2,
    required: true,
    text: "What Safety subgroup table do you want to report on?",
    tooltip: "One table per subgroup.",
  },
  qSpecialSection1Groupings: {
    number: 3,
    text: "Which groupings do you want to compare? Select the groupings from the Description of Studies page to include for this subgroup.",
  },
  qSpecialAdditionalGroupingName: {
    number: 4,
    text: "Which additional groupings do you want to compare? Name the grouping and then select the studies in this grouping.",
  },
  qLabComparisonType: {
    number: 5,
    // The endpoint has no wording for this question yet; it is the same
    // question as Q7 of the Description of Studies page.
    textKey: "qComparisonType",
    text: "How is the grouping compared?",
  },
  // Q6 / Q7 below are the Description of Studies branch questions (its Q8 / Q9)
  // shown for the comparison type picked in Q5.
  qNonComparativeGroupNames: {
    number: 6,
    text: "What are the actual names used to describe the treatment/analysis groups in the column headers?",
  },
  qTreatmentGroupNames: {
    number: 6,
    text: "What are the actual names used to describe the treatment/analysis groups in the column headers? Please define the role for each column name.",
  },
  qComparisonPairs: {
    number: 7,
    text: "Which dose/treatment groups should be compared?",
  },
  qDoseGroups: {
    number: 6,
    text: "Please list the dose group column headers from lowest to highest, starting with Placebo if present.",
  },
};

// Q1 always reports on these three subgroups: they are pre-populated and locked
// (shown as chips without a remove control), so the answer is always these plus
// whatever the user adds.
export const SCS_SPECIAL_LOCKED_SUBGROUPS = ["Gender", "Age", "Race"];

// Suggestions offered by Q1 on top of the free text the user can type in.
//
// TODO: the questions endpoint carries no option list for these yet, so the
// suggestions are hardcoded here — swap them for the served list once it is
// available.
export const SCS_SPECIAL_SUBGROUP_SUGGESTIONS = [
  "Alcohol use",
  "Smoking",
  "Liver disease",
  "Renal disease",
  "Drug interactions",
];
